// extracted by mini-css-extract-plugin
export default {"matchDetailsContainer":"eICoQ","matchTitle":"xKnGS","matchScores":"jiydX","singleEvent":"es8DJ","matchInformation":"vMAMi","liveIndicatorIcon":"uqUro"};